var doorsG = new DoorsGeneral(),
    doorsL = new DoorsLibrary(),
    doorI = new DoorsInitiate(),
    apiData, productData;

// ----------------------------------------------------- //
// General
// ----------------------------------------------------- //
function DoorsGeneral(){

  this.accordion = function(){
    var accordionDiv = $('.accordion-container');
    if( accordionDiv.length ){
      // $('.accordion-header').addClass('inactive-header');
  
      //Set The Accordion Content Width
      var contentwidth = $('.accordion-header').width();
      $('.accordion-content').css({'width' : contentwidth });
  
      //Open The First Accordion Section When Page Loads
      // $('.accordion-container .accordion-header:first-of-type').addClass('active-header').removeClass('inactive-header');
      // $('.accordion-container .accordion-content:nth-of-type(2)').slideDown().addClass('open-content');
  
      // The Accordion Effect
      $('.accordion-header').click(function () {
        if($(this).is('.inactive-header')) {
            $(this).siblings('.active-header').removeClass('active-header').addClass('inactive-header').next().slideToggle().removeClass('open-content');
            $(this).addClass('active-header').removeClass('inactive-header');
            $(this).next().slideToggle().addClass('open-content');
        } else {
            $(this).removeClass('active-header').addClass('inactive-header');
            $(this).next().slideToggle().removeClass('open-content');
        }
      });
    }
  };
}

// ----------------------------------------------------- //
// Library
// ----------------------------------------------------- //
function DoorsLibrary(){  

  this.get = function(url, callback){
    $.getJSON(url).done(
      function(data){
        if ( callback ){
          callback(data);
        }
      }
    ).fail(function(xhr, status, error) {
      console.error('AJAX request failed:', error);
      if (callback) {
        callback(null); // Pass null to indicate failure
      }
    });
  };

  this.post = function(url, data, callback){
    let params = {
      url: url,
      data: data, 
      dataType: 'json'
    };
    $.post(params).done(
      function(data){
        if ( callback ){
          callback(data);
        }
      }
    ).fail();
  };

  this.getParam = function(sParam){
    var sPageURL = window.location.search.substring(1);

    var sURLVariables = sPageURL.split('&');
  
    for (var i = 0; i < sURLVariables.length; i++) {
      var sParameterName = sURLVariables[i].split('=');
  
      if (sParameterName[0] === sParam) {
        return sParameterName[1];
      }
    }
  };

  this.loader = function(state){
    let $loader = $('.loader-wrapper');

    if ( state === 'hide' ){
      $loader.addClass('hide');
      $('body').removeClass('overflow-hidden');
      return false;
    } 
    
    if ( state === 'show' ){
      $loader.removeClass('hide');
      $('body').addClass('overflow-hidden');
      return false;
    }
  };

  this.removeDuplicates = function(originalArray, prop) {
    var newArray = [];
    var lookupObject  = {};

    for(var i in originalArray) {
       lookupObject[originalArray[i][prop]] = originalArray[i];
    }

    for(i in lookupObject) {
        newArray.push(lookupObject[i]);
    }
     return newArray;
  };

  this.sortAlphabetically = function(data, property){
    data.sort(function(a, b){
      if(a[property] < b[property]) { return -1; }
      if(a[property] > b[property]) { return 1; }
      return 0;
    })
  };
}

// ----------------------------------------------------- //
// Initiate
// ----------------------------------------------------- //
function DoorsInitiate(){
  var url = 'https://bestdoors.enableit.co.nz/api/',
    api = {
      'fire': url + 'collectionProducts/1',
      'fireProduct': url + 'shopifyProductDetails/',
      'commercial': url + 'collectionProducts/2',
      'residential': url + 'collectionProducts/3'
    },
    selector = {
      'body': '#filter-wrapper',
      'productSelect': '#filter-product',
      'frameSelect': '#filter-frame',
      'wallSelect': '#filter-wall',
      'typeSelect': '#filter-types',
      'brandSelect': '#filter-brands',
      'filterContent': '[data-filter-content]'
    },
    $selector = {
      'body': $(selector.body),
      'productSelect': $(selector.productSelect),
      'frameSelect': $(selector.frameSelect),
      'wallSelect': $(selector.wallSelect),
      'typeSelect': $(selector.typeSelect),
      'brandSelect': $(selector.brandSelect),
      'filterContent': $(selector.filterContent)
    },
    pageType = $selector.body.attr('data-type') ? $selector.body.attr('data-type').toLowerCase() : 'fire',
    dataType = $selector.body.attr('data-filter-type') || 'hardware',
    productId = $selector.body.attr('data-product-id') || '';

  this.init = function(){
    // Check if required elements exist
    if (!$selector.body.length) {
      console.warn('Filter wrapper not found');
      return;
    }

    if ( dataType === 'installation' ){
      doorsL.get(api[pageType], function (response) {
        if (response && response.length > 0) {
          apiData = response;
          this.sortData(apiData);
        } else {
          console.warn('No installation data received');
          $('[data-filter-content]').html('<div style="text-align: center; padding: 20px;"><p>No installation data available</p></div>');
        }
      }.bind(this) );
    } else if ( productId && dataType === 'hardware' ){
      console.log('Loading hardware data for product ID:', productId);
      doorsL.get(api.fireProduct + productId, function (response) {
        if (response) {
          console.log('Received response:', response);
          productData = [];
          productData.push(response);
          console.log('Product data array:', productData);
          this.generateHardwareFilter(productData);
          this.sortData(productData, productId);
        } else {
          console.warn('No product data received for ID:', productId);
          $('[data-filter-content]').html('<div style="text-align: center; padding: 20px;"><p>No hardware data available for this product</p></div>');
        }
      }.bind(this) );
    } else if ( !productId && dataType === 'hardware' ){
      console.log('Loading hardware data for collection type:', pageType);
      doorsL.get(api[pageType], function (response) {
        if (response && response.length > 0) {
          console.log('Received response:', response);
          apiData = response;
          this.generateHardwareFilter(apiData);
          this.sortData(apiData);
        } else {
          console.warn('No hardware data received');
          $('[data-filter-content]').html('<div style="text-align: center; padding: 20px;"><p>No hardware data available</p></div>');
        }
      }.bind(this) );
    }

  };

  this.generateHardwareFilter = function(data){
    if (!data || !Array.isArray(data) || data.length === 0) {
      console.warn('No data provided to generateHardwareFilter');
      return;
    }

    console.log('generateHardwareFilter - processing data:', data.length, 'products');

    let filterTypeData = [], 
        filterBrandData = [],
        uniqueTypeData,
        uniqueBrandData,
        typeOptionsHtml = '',
        brandOptionsHtml = '';

    data.forEach(function(product, index){
      if (!product.hardware || !Array.isArray(product.hardware)) {
        console.warn('Product', index, 'has no hardware array:', product);
        return;
      }
      
      console.log('Product', index, 'has', product.hardware.length, 'hardware items');
      
      product.hardware.forEach(function(hardwareData){
        if (hardwareData.mainGroupDetails && hardwareData.brand) {
          filterTypeData.push({
            name: hardwareData.mainGroupDetails.name,
            id: hardwareData.mainGroupDetails.id
          });
      
          filterBrandData.push({
            name: hardwareData.brand.name,
            id: hardwareData.brand.id
          });
        }
      });
    });

    console.log('Found', filterTypeData.length, 'type entries and', filterBrandData.length, 'brand entries');

    uniqueTypeData = doorsL.removeDuplicates(filterTypeData, 'id');
    uniqueBrandData = doorsL.removeDuplicates(filterBrandData, 'id');

    console.log('After removing duplicates:', uniqueTypeData.length, 'types and', uniqueBrandData.length, 'brands');

    doorsL.sortAlphabetically(uniqueTypeData, 'name');
    doorsL.sortAlphabetically(uniqueBrandData, 'name');

    typeOptionsHtml = generateOptions(uniqueTypeData);
    brandOptionsHtml = generateOptions(uniqueBrandData);

    if ($selector.typeSelect.length) {
      $selector.typeSelect.empty(); // Clear existing options
      $selector.typeSelect.append(typeOptionsHtml);
      console.log('Added', uniqueTypeData.length + 1, 'type options (including "All")');
    }
    if ($selector.brandSelect.length) {
      $selector.brandSelect.empty(); // Clear existing options
      $selector.brandSelect.append(brandOptionsHtml);
      console.log('Added', uniqueBrandData.length + 1, 'brand options (including "All")');
    }

    function generateOptions(array){
      let temp = '<option value="All">All</option>'; // Add "All" option at the beginning

      if (Array.isArray(array)) {
        array.forEach(function(arr){
          if (arr && arr.id && arr.name) {
            temp += '<option value="' + arr.id + '">' + arr.name + '</option>';
          }
        });
      }

      return temp;
    }
  };

  this.sortDataInit = function(){
    if ( dataType === 'installation' ){
      this.sortData(apiData);
      return false;
    }

    if ( productId && dataType === 'hardware' ){
      this.sortData(productData);
      return false;
    }

    if ( !productId && dataType === 'hardware' ){
      this.sortData(apiData);
    }
  };

  this.sortData = function(generatedData, product_Id){
    if (!generatedData || !Array.isArray(generatedData)) {
      console.warn('No valid data provided to sortData');
      return;
    }

    let frame = $selector.frameSelect.length ? $selector.frameSelect.val() : null,
        wall = $selector.wallSelect.length ? $selector.wallSelect.val() : null,
        type = $selector.typeSelect.length ? $selector.typeSelect.val() : null,
        brand = $selector.brandSelect.length ? $selector.brandSelect.val() : null,
        cloneData = JSON.parse(JSON.stringify(generatedData)),
        filteredData = []; 

    if ( !product_Id ){
      product_Id = $selector.productSelect.length ? $selector.productSelect.val() : null;
    }

    console.log('Filter values:', {
      product_Id: product_Id,
      frame: frame,
      wall: wall,
      type: type,
      brand: brand
    });

    if ( productId && dataType === 'hardware' ){
      filteredData = cloneData;
    } else if ( product_Id === 'All' ){
      filteredData = cloneData;
    } else if ( product_Id ){
      cloneData.forEach(product => {
        if ( product.variantId === product_Id ){
          filteredData.push(product);
        }
      });
    }
    
    if (dataType === 'installation'){
      sortInstallation();
      this.generateInstallation(filteredData);
    }

    if (dataType === 'hardware'){
      sortHardwareProduct();
      this.generateHardware(filteredData);
    }

    function sortInstallation(){
      // Only filter by frame if a specific frame is selected (not "All")
      if ( frame && frame !== 'All' ){
        var tempData = [];

        filteredData.forEach(product => {
          let tempProduct = product,
              tempInstallation = [];

          if (product.additional_product_data && Array.isArray(product.additional_product_data)) {
            product.additional_product_data.forEach(installData => {
              if ( installData.frameType === frame ){
                tempInstallation.push(installData);
              }
            });
          }

          tempProduct.additional_product_data = tempInstallation;
          tempData.push(tempProduct);
        });

        filteredData = tempData;
      }

      // Only filter by wall if a specific wall is selected (not "All")
      if ( wall && wall !== 'All' ){
        var tempData = [];

        filteredData.forEach(product => {
          let tempProduct = product,
              tempInstallation = [];

          if (product.additional_product_data && Array.isArray(product.additional_product_data)) {
            product.additional_product_data.forEach(installData => {
              if ( installData.wallType === wall ){
                tempInstallation.push(installData);
              }
            });
          }

          tempProduct.additional_product_data = tempInstallation;
          tempData.push(tempProduct);
        });

        filteredData = tempData;
      }
    }

    function sortHardwareProduct(){
      console.log('sortHardwareProduct - type:', type, 'brand:', brand);
      
      // Only filter by type if a specific type is selected (not "All")
      if ( type && type !== 'All' ){
        console.log('Filtering by type:', type);
        var tempData = [];

        filteredData.forEach(product => {
          let tempProduct = product,
              tempHardware = [];

          if (product.hardware && Array.isArray(product.hardware)) {
            product.hardware.forEach(hardwareData => {
              if ( hardwareData.mainGroupDetails && hardwareData.mainGroupDetails.id.toString() === type.toString() ){
                tempHardware.push(hardwareData);
              } else if ( hardwareData.subGroupDetails ){
                if ( hardwareData.mainGroupDetails && hardwareData.mainGroupDetails.id.toString() + ' > ' + hardwareData.subGroupDetails.id.toString() === type ){
                  tempHardware.push(hardwareData);
                }
              }
            });
          }

          tempProduct.hardware = tempHardware;
          tempData.push(tempProduct);
        });

        filteredData = tempData;
        console.log('After type filtering, hardware count:', filteredData[0] ? filteredData[0].hardware.length : 0);
      } else {
        console.log('No type filtering applied (type is "All" or null)');
      }
      
      // Only filter by brand if a specific brand is selected (not "All")
      if ( brand && brand !== 'All' ){
        console.log('Filtering by brand:', brand);
        var tempData = [];

        filteredData.forEach(product => {
          let tempProduct = product,
              tempHardware = [];

          if (product.hardware && Array.isArray(product.hardware)) {
            product.hardware.forEach(hardwareData => {
              if ( hardwareData.brand && hardwareData.brand.id.toString() === brand.toString() ){
                tempHardware.push(hardwareData);
              }
            });
          }

          tempProduct.hardware = tempHardware;
          tempData.push(tempProduct);
        });

        filteredData = tempData;
        console.log('After brand filtering, hardware count:', filteredData[0] ? filteredData[0].hardware.length : 0);
      } else {
        console.log('No brand filtering applied (brand is "All" or null)');
      }
      
      console.log('Final hardware count:', filteredData[0] ? filteredData[0].hardware.length : 0);
    }
  };

  this.generateInstallation = function(data){
    var contentHtml = '',
        $contentContainer = $selector.filterContent,
        noData = false;

    if (data.length === 0) {
      noData = true;
    }

    data.forEach(product => {
      if (product.additional_product_data.length){
        //Create product header
        contentHtml += '<div class="header">' +
                          '<p class="h6">' +
                            product.title +
                          '</p>' +
                        '</div>';
      }

      if (product.additional_product_data.length === 0) {
        noData = true;
      }
      product.additional_product_data.forEach(installation => {
        if ( installation.installation == null ){
          return;
        }
        //Convert Initials to Text
        let wallText = [
              ['M', 'Masonry'],
              ['SW', 'Speedwall'],
              ['SS', 'Steel Stud'],
              ['TS', 'Timber Stud']
            ],
            frameText = [
              ['S', 'Steel'],
              ['T', 'Timber'],
              ['L', 'Slider']
            ],
            wallTitle, frameTitle;
        wallText.forEach(text=> {
          if (installation.wallType == text[0]) wallTitle = text[1];
        });
        frameText.forEach(text=> {
          if (installation.frameType == text[0]) frameTitle = text[1];
        });

        let splitInstallations = installation.installation.replace('<hr>', '<hr />').replace('<hr/>', '<hr />').split('<hr />');
        splitInstallations.forEach(splitInstallation => {
          contentHtml += '<div class="filter-content installation-filter-content">' +
                            '<div class="filter-content-header">' + 
                              '<p>Wall Type: <span>' + wallTitle + '</span></p>' + 
                              '<p>Frame Type: <span>' + frameTitle + '</span></p>' + 
                            '</div>' +
                            '<div class="filter-content-content">' + 
                              splitInstallation +
                            '</div>' +
                          '</div>'; 
        });
      });

    });

    if (noData){
      contentHtml += '<div class="no-filter-item text-center">There are no results that match your search</div>';
    }

    $contentContainer.html(contentHtml);
  };

  this.generateHardware = function(data){
    if (!data || !Array.isArray(data) || data.length === 0) {
      console.warn('No data provided to generateHardware');
      return;
    }

    console.log('generateHardware - processing data:', data.length, 'products');

    var contentHtml = '',
        $contentContainer = $selector.filterContent,
        hardwareArray = [],
        variantSku = $selector.productSelect.length ? $selector.productSelect.find('option:selected').text() : '',
        currentMainType = '',
        currentSubType = '';

    if (!$contentContainer.length) {
      console.warn('Content container not found');
      return;
    }

    data.forEach(function(product, index){
      if (product.hardware && Array.isArray(product.hardware)) {
        console.log('Product', index, 'has', product.hardware.length, 'hardware items');
        console.log('Sample hardware item structure:', product.hardware[0]);
        let temp = product.hardware.map(function(x){
          if (x && x.mainGroupDetails) {
            if (x.subGroupDetails){
              x.fullTypeName = x.mainGroupDetails.name + ' > ' + x.subGroupDetails.name;
            } else {
              x.fullTypeName = x.mainGroupDetails.name;
            }
            return x;
          }
          return null;
        }).filter(function(x) { return x !== null; });
        hardwareArray = hardwareArray.concat(temp);
      }
    });

    console.log('Total hardware items found:', hardwareArray.length);

    // Apply deduplication only on collection pages (when productId is not present)
    // On product pages, we want to show all hardware items without deduplication
    if (!productId) {
      // This is a collection page - apply deduplication
      hardwareArray = doorsL.removeDuplicates(hardwareArray, 'brandProductId');
      console.log('After deduplication (collection page):', hardwareArray.length, 'items');
    } else {
      // This is a product page - skip deduplication to show all items
      console.log('Skipping deduplication (product page):', hardwareArray.length, 'items');
    }
    
    doorsL.sortAlphabetically(hardwareArray, 'fullTypeName');
    console.log('After sorting:', hardwareArray.length, 'items');

    hardwareArray.forEach(function(hardwareItem, index){
      console.log('Processing hardware item', index, ':', hardwareItem);
      
      let firstOfGroup = false;

      //Generate MainGroup Header
      if ( hardwareItem.mainGroupDetails && hardwareItem.mainGroupDetails.id != currentMainType ){
        currentMainType = hardwareItem.mainGroupDetails.id;
        contentHtml += '<div class="main-group">' + hardwareItem.mainGroupDetails.name + '</div>';
        firstOfGroup = true;
      }

      //Generate SubGroup Header
      if ( hardwareItem.subGroupDetails && hardwareItem.subGroupDetails.id != currentSubType ){
        currentSubType = hardwareItem.subGroupDetails.id;
        contentHtml += '<div class="sub-group">' + hardwareItem.subGroupDetails.name + '</div>';
        firstOfGroup = true;
      }

      //Generate Description
      if ( firstOfGroup ){
        contentHtml += '<div class="table-header">'+ 
                          '<span>Brand</span>' + 
                          '<span>Series</span>' + 
                          '<span>Product Door Code</span>' + 
                        '</div>';
      }

      //Change variantSku to the full list if page is a collection page
      if ( hardwareItem.productSkus ){
        if ( hardwareItem.productSkus.length > 0 ){
          variantSku = hardwareItem.productSkus.join(', ');
        } else {
          variantSku = '';
          let skuArr = Object.entries(hardwareItem.productSkus);
          skuArr.forEach(function(sku, i){
            variantSku += sku[1];
            if ( skuArr.length !== i + 1 ){
              variantSku += ', ';
            }
          });
        }
      } else {
        // Fallback to product SKU if productSkus doesn't exist
        variantSku = $selector.productSelect.length ? $selector.productSelect.find('option:selected').text() : '';
      }

      //Generate Hardware Item
      if (hardwareItem.brand && hardwareItem.brandDetails) {
        contentHtml += '<div class="series">'+ 
                          '<span>' + (hardwareItem.brand.name || '') + '</span>' + 
                          '<span>' + (hardwareItem.brandDetails.series || '') + '</span>' + 
                          '<span>' + (variantSku || '') + '</span>' + 
                        '</div>';
      }
    });

    console.log('Generated HTML length:', contentHtml.length);

    if (hardwareArray.length === 0){
      contentHtml += '<div class="no-filter-item text-center">There are no results that match your search</div>';
    }

    $contentContainer.html(contentHtml);
  };

}

// ----------------------------------------------------- //
// Initiate
// ----------------------------------------------------- //
$(function(){
  doorsG.accordion();
  
  // Add a small delay to ensure DOM is fully rendered
  setTimeout(function() {
    doorI.init();
  }, 100);

  //Trigger
  let $filterContainer = $('.filter-container'),
      $resetBtn = $('[data-filter-reset]');

  $filterContainer.on('change', (e) => {
    doorI.sortDataInit();
  });

  $resetBtn.on('click', function(e){
    $('.filter-container select:not(.disabled)').val('All');
    $filterContainer.trigger('change');
  });

});